import { Card } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/form";
import { Button } from "@/components/ui/button";
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

export const AppointmentConfirmCard = ({ isEdit, onCancel, isPending }) => {
    return (
        <Card size="lg" className="grid-cols-12">
            <div className="col-span-full">
                <h2 className="mb-6 text-xl font-semibold">
                    Confirm before booking
                </h2>
            </div>
            <div className="col-span-full mb-6 grid max-w-6xl grid-cols-subgrid gap-y-6 md:gap-x-8">
                <div className="col-span-full">
                    <Checkbox
                        name="confirmContact"
                        label="I consent to my contact details being shared with my selected clinician"
                        description="So they can contact me about this appointment."
                        labelPlacement="end"
                    />
                </div>
                <div className="col-span-full flex items-center">
                    <hr className="my-4 flex-auto border border-gray-200" />
                </div>
                <div className="col-span-full">
                    <Checkbox
                        name="confirmationType"
                        label="I confirm that I am 18 years of age or older"
                        description="You must be at least 18 to book healthcare services on Welnido."
                        labelPlacement="end"
                        value="1"
                        isMulti
                    />
                </div>
                <div className="col-span-full flex items-center gap-2">
                    <hr className="flex-auto border border-gray-200" />
                    <span className="text-neutral-500">or</span>
                    <hr className="flex-auto border border-gray-200" />
                </div>
                <div className="col-span-full">
                    <Checkbox
                        name="confirmationType"
                        label="I have authority to book on behalf of another person"
                        description="I confirm I have the legal authority or express consent of the individual (or their parent/guardian if under 18) to book this appointment on their behalf."
                        labelPlacement="end"
                        value="2"
                        isMulti
                    />
                </div>
                <div className="col-span-full mt-10 flex flex-wrap items-end gap-3">
                    <Button
                        type="submit"
                        variant="primary"
                        disabled={isPending}
                    >
                        <CheckIcon />

                        {isPending
                            ? isEdit
                                ? "Updating..."
                                : "Requesting..."
                            : isEdit
                              ? "Edit appointment"
                              : "Request appointment"}
                    </Button>
                    <Button
                        type="button"
                        onClick={() => onCancel()}
                        variant="secondary"
                        disabled={isPending}
                    >
                        <XMarkIcon />
                        Cancel
                    </Button>
                </div>
            </div>
        </Card>
    );
};
